import {
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import { addAuthHeaders } from '../api';
import { config } from '../config/worker';
import { Company } from '../types/company';

// Company selection API - targets Mannskapsplanlegger Backend
export const companyApi = createApi({
  reducerPath: 'company',
  baseQuery: fetchBaseQuery({
    baseUrl: config.API_URL,
    prepareHeaders: (h) => addAuthHeaders(config, h),
  }),
  tagTypes: ['myCompany'],
  endpoints: (builder) => ({
    getMyCompany: builder.query<Company | undefined, void>({
      async queryFn(_arg, _queryApi, _extraOptions, baseQueryFetch) {
        const result = await baseQueryFetch({ url: '/me/company' });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const error = result.error as any;
        if (error?.status === 404 || error?.originalStatus === 404) {
          return { data: undefined };
        }
        return result.data
          ? { data: result.data as Company }
          : { error: result.error as FetchBaseQueryError };
      },
      providesTags: ['myCompany'],
    }),
    setMyCompany: builder.mutation<string, string>({
      query: (companyName) => ({
        url: '/me/company',
        method: 'PUT',
        body: { companyName },
        headers: { 'Content-Type': 'application/json' },
        responseHandler: async (response) => {
          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Error ${response.status}: ${errorText || response.statusText}`);
          }
          return response.text();
        },
      }),
      invalidatesTags: ['myCompany'],
    }),
    getCompanyList: builder.query<string[], void>({
      query: () => '/companies',
      providesTags: ['myCompany'],
    }),
  }),
});

export const {
  useGetMyCompanyQuery,
  useSetMyCompanyMutation,
  useGetCompanyListQuery,
} = companyApi;

export default companyApi.reducer;
